import { inviteTokenFromHash, savePendingInvite } from './pendingInvite'

const INVITE_PATH = /^\/invite\/?$/

type Arrival = Pick<Location, 'pathname' | 'search' | 'hash'>
type AddressBar = Pick<History, 'state' | 'replaceState'>

/**
 * On arrival at `/invite#<token>`, keeps the token as the pending invite (pendingInvite) and takes the fragment out of
 * the address bar and history. main.tsx runs it first, through `src/inviteArrival.ts`, so Sentry, analytics and the
 * router start on a plain `/invite` and never read the token. Any other fragment on `/invite` goes too: a cut-off
 * token is still part of one. Returns the token, or null. useInviteToken still covers a link pasted into a tab that
 * is already on the page.
 */
export function takeInviteFragment(location: Arrival = window.location, history: AddressBar = window.history, now = Date.now()) {
  if (!INVITE_PATH.test(location.pathname) || !location.hash) return null
  const token = inviteTokenFromHash(location.hash)
  if (token) savePendingInvite(token, now)
  history.replaceState(history.state, '', `${location.pathname}${location.search}`)
  return token
}
